import { useContext } from 'react';
import { TemplatesTabsContext } from '../context/TemplatesTabsContext';

export const useTabs = () => useContext(TemplatesTabsContext);
